// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-1-FjF","loyalty__link":"loyalty__link-FRnNe","seatNumber":"seatNumber-1-u15"};